import moment from 'moment';

const startDate = moment().subtract(30, 'days');
const currentDate = moment();

const schema = {
    movementDesc: {
        id: 'movementDesc',
        label: 'N° da carteirinha ou nome',
        placeholder: '',
        type: 'text',
        required: true,
    },
    movementProtocol: {
        id: 'movementProtocol',
        label: 'Protocolo',
        placeholder: '',
        type: 'text',
        required: true,
    },
    movementDate: {
        id: 'movementDate',
        label: 'Período',
        placeholder: '',
        type: 'daterange',
        required: true,
        value: [startDate, currentDate],
    },
    movementType: {
        id: 'movementType',
        label: 'Tipo de operação',
        placeholder: 'Todos',
        type: 'select',
        required: true,
    },
    movementStatus: {
        id: 'movementStatus',
        label: 'Status',
        placeholder: 'Todos',
        type: 'select',
        required: true,
    },
};

export default schema;
